export enum Conclusion {
  Pass = 'מתאים',
  Fail = 'לא מתאים',
  NoConclusion = 'ללא מסקנה',
  NotApplicable = 'לא ישים'
}
